import { Outlet } from 'react-router-dom';
import AdminSidebar from '../components/common/AdminSidebar';

const AdminLayout = () => {
  return (
    <div className="relative min-h-screen">
      <AdminSidebar />
      {/* Thêm class ml-64 để tạo khoảng trống cho Sidebar */}
      <main className="ml-64 flex-grow p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;